import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Chip from '@material-ui/core/Chip'

const useStyles = makeStyles(() => ({
  chipWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

const StyledChip = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.grey,
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
  },
  label: {
    fontSize: theme.typography.pxToRem(14),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
  },
}))(Chip)

interface LabelChipProps {
  label: React.ReactNode
  icon?: React.ReactElement
  className?: string
}

const LabelChip = ({ label, icon, className }: LabelChipProps) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.chipWrapper, className)}>
      <StyledChip label={label} avatar={<>{icon}</>} />
    </div>
  )
}

export default LabelChip
